<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div v-if="isAddBarcode === true" class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <b>{{ typeModal }} Barcode</b>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-md-3">
                  <label>
                    <b>Page</b>
                  </label>

                  <input
                    type="number"
                    class="form-control form-control-sm"
                    v-model="pageBarcode"
                  >
                </div>

                <div class="col-md-9">
                  <label>
                    <b>PDF Field Name</b>
                  </label>

                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="pdfFieldBarcode"
                  >
                </div>
              </div>

              <br>

              <div class="row">
                <div class="col-sm-12">
                  <label><b>Model</b></label>

                  <textarea
                    id="barcodeModel"
                    v-model="barcodeModel"
                    class="form-control form-control-sm"
                    rows="10">
                  </textarea>
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                class="btn btn-secondary"
                @click="isAddBarcode = false"
              >
                Cancel
              </button>

              <button
                :disabled="pageBarcode !== '' && pdfFieldBarcode !== '' && barcodeModel !== '' ? false : true"
                class="btn btn-success"
                @click="addBarcodeTemplate"
              >
                Save
              </button>
            </slot>
          </div>
        </div>

        <div v-else-if="isDeleteBarcode === true" class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <b>Delete Barcode</b>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <center><h3>Are you sure delete this barcode.?</h3></center>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                class="btn btn-danger"
                @click="confirmDelete"
              >
                Delete
              </button>

              <button
                class="btn btn-secondary"
                @click="isDeleteBarcode = false"
              >
                Cancel
              </button>
            </slot>
          </div>
        </div>

        <div v-else class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <b>Barcode Template</b>

              <a
                class="btn btn-success text-white float-right"
                @click="addBarcodeModal"
              >Add</a>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">

              <table v-if="listBarcode !== undefined && listBarcode.length > 0" class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Page</th>
                    <th>PDF Field name</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(barcode, index) in listBarcode"
                    :key="index"
                  >
                    <td>
                      {{barcode.page}}
                    </td>

                    <td>
                      {{barcode.pdfFieldBarcode}}
                    </td>

                    <td>
                      <a @click="getBarcode({
                        barcodeId: barcode._id,
                        index
                      })" style="color: #007bff !important;">Edit</a> |
                      <a @click="deleteBarcode({
                        barcodeId: barcode._id,
                        index
                      })" style="color: #007bff !important;">Delete</a>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h5 v-else>
                No barcode templates recorded.
              </h5>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-secondary modal-danger-button" @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'barcode-template-modal',

  data () {
    return {
      barcodeEditIndex: null,
      barcodeId: '',
      barcodeModel: '',
      isAddBarcode: false,
      pdfFieldBarcode: '',
      pageBarcode: this.$store.state.fileCurrentPage,

      listBarcode: [],

      isDeleteBarcode: false,
      deleteBarcodeIndex: null,
      deleteBarcodeId: '',

      typeModal: ''
    }
  },

  mounted () {
    this.$store.dispatch('getListBarcodeTemplate').then(response => {
      this.listBarcode = response.data
    })
  },

  methods: {
    addBarcodeModal () {
      this.typeModal = 'Add'
      this.isAddBarcode = true
      this.barcodeId = ''
      this.barcodeModel = ''
      this.pdfFieldBarcode = ''
      this.pageBarcode = this.$store.state.fileCurrentPage
    },

    addBarcodeTemplate () {
      if (this.barcodeId !== '') this.editBarcode()
      else {
        let barcodeTemplate = {
          formId: this.$store.state.templates[this.$store.state.currentTemplateName].formId,
          page: this.pageBarcode,
          pdfFieldBarcode: this.pdfFieldBarcode,
          model: this.barcodeModel
        }

        this.$store.dispatch('addBarcodeTemplate', barcodeTemplate).then(response => {
          if (response.data.success === true) {
            this.$bus.emit('addNotification', {
              title: 'Barcode Template',
              body: 'Barcode saved succesfully.',
              type: 'success'
            })

            barcodeTemplate._id = response.data.barcodeId

            this.listBarcode.push(barcodeTemplate)

            this.isAddBarcode = false
          } else {
            this.$bus.emit('addNotification', {
              title: 'Barcode Template',
              body: 'Ocurred an error.',
              type: 'error'
            })
          }
        })
      }
    },

    editBarcode () {
      let barcodeTemplate = {
        _id: this.barcodeId,
        formId: this.$store.state.templates[this.$store.state.currentTemplateName].formId,
        page: this.pageBarcode,
        pdfFieldBarcode: this.pdfFieldBarcode,
        model: this.barcodeModel
      }

      this.$store.dispatch('updateBarcodeTemplate', barcodeTemplate).then(response => {
        if (response.data.success === true) {
          this.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Barcode updated succesfully.',
            type: 'success'
          })

          this.listBarcode[this.barcodeEditIndex] = barcodeTemplate

          this.barcodeEditIndex = null
          this.barcodeId = ''
          this.isAddBarcode = false
        } else {
          this.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Ocurred an error.',
            type: 'error'
          })
        }
      })
    },

    getBarcode (payload) {
      this.$store.dispatch('getBarcodeTemplate', payload.barcodeId).then(response => {
        if (response.data.length > 0) {
          let editBarcode = response.data[0]

          this.barcodeEditIndex = payload.index
          this.barcodeId = editBarcode._id
          this.pageBarcode = editBarcode.page
          this.pdfFieldBarcode = editBarcode.pdfFieldBarcode
          this.barcodeModel = editBarcode.model

          this.typeModal = 'Edit'

          this.isAddBarcode = true
        } else {
          this.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Ocurred an error.',
            type: 'error'
          })
        }
      })
    },

    deleteBarcode (payload) {
      this.deleteBarcodeIndex = payload.index
      this.deleteBarcodeId = payload.barcodeId

      this.isDeleteBarcode = true
    },

    confirmDelete () {
      this.$store.dispatch('deleteBarcodeTemplate', this.deleteBarcodeId).then(response => {
        if (response.data.success === true) {
          this.listBarcode.splice(this.deleteBarcodeIndex, 1)

          this.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Barcode template deleted succesfully.',
            type: 'success'
          })

          this.deleteBarcodeIndex = null
          this.deleteBarcodeId = ''
          this.isDeleteBarcode = false
        } else {
          this.$bus.emit('addNotification', {
            title: 'Barcode Template',
            body: 'Ocurred an error.',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  a {
    cursor: pointer;
  }

  .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 800px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  height: auto;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// src/components/editor/modals/BarcodeTemplateModal.vue